import React, {Component} from 'react';
import data from '../../data-en'

import './footer.css';

class Footer extends Component {

  render() {
    let copyright = data.footer.copyright;
    return (
      <div className="footer">
        {copyright}
      </div>
    );
  }
}

export default {Footer}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js